<script setup lang="ts">

</script>

<template>
<option value='[a] Erstsemesterarbeit'>[a] Erstsemesterarbeit</option>
<option value='[b] Inhaltliche Veranstaltungen'>[b] Inhaltliche Veranstaltungen</option>
<option value='[c] Erstsemesterfahrt'>[c] Erstsemesterfahrt</option>
<option value='[d] Klausurfahrten'>[d] Klausurfahrten</option>
<option value='[e] Teilnahme Fachschaftentagung'>[e] Teilnahme Fachschaftentagung</option>
<option value='[f] Bildungsfahrt'>[f] Bildungsfahrt</option>
<option value='[g] Tagesexkursion'>[g] Tagesexkursion</option>
<option value='[h] Sachmittel'>[h] Sachmittel</option>
<option value='[i] Ausrichtung Fachschaftentagung'>[i] Ausrichtung Fachschaftentagung</option>
<option value='[j] Fachschaftskleidung'>[j] Fachschaftskleidung</option>
<option value='[k] Fachschaftsneugründung'>[k] Fachschaftsneugründung</option>
<option value='[l] Schulungen'>[l] Schulungen</option>
<option value='[m] Wiederaufbauunterstützung'>[m] Wiederaufbauunterstützung</option>
<option value='Außerhalb KritKat'>Außerhalb KritKat</option>
</template>

<style scoped>

</style>